import { formTypes } from '../../../form/form.constants';
import { ComplianceForm } from './compliance-form.model';
import {ProjectForm} from '../../../project/models/form.model';
import {Validators} from '@angular/forms';

export class ComplianceOptOutForm extends ProjectForm {

  hasCompanyChosenOptOut?: boolean;
  companyUnderstandsExA?: boolean;

  constructor() {
    super();
    this.init();
  }

  init() {
    super.init();
    this.type = formTypes.coo.abbrev;
  }

  get qualifier() {
    return '';
  }
}
